import type { IconData } from '@stacksjs/iconify-core'

export const otherUiRocket: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3 8.126V5l5-5l5 5v3.126a4.002 4.002 0 0 1 0 7.748V13h-2a3 3 0 1 1-6 0H3v2.874a4.002 4.002 0 0 1 0-7.748m5-.878a1.248 1.248 0 1 0 0-2.496a1.248 1.248 0 0 0 0 2.496\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default otherUiRocket
